import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ConsoleIcon from 'components/icons/consoleIcon';
import lfOnDemandIcon from 'assets/icons/Icon_Headphone_S.svg';
import TimerIcon from '@material-ui/icons/Timer';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';
import CastConnectedIcon from '@material-ui/icons/CastConnected';
import innerAssetRowStyles from 'assets/jss/components/innerAssetRow'


function minTommss(minutes) {
    var sign = minutes < 0 ? "-" : "";
    var min = Math.floor(Math.abs(minutes));
    var sec = Math.floor((Math.abs(minutes) * 60) % 60);
    return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
}

export default function Innerasset(props) {
    const { asset, showAvailable, ...rest } = props;
    const classes = innerAssetRowStyles();
    const { t } = useTranslation();

    const dateformatting = () => {
        if (!asset.inUseSince)
            return t('notConnected');
        const d = Date.parse(asset.inUseSince);
        const now = new Date();
        const elapsedTime = now - d;
        const inSeconds = elapsedTime / 1000;
        var inMinutes = inSeconds / 60;
        const inHours = inMinutes / 60;
        if (inMinutes < 0)
            inMinutes = 0;
        if (inHours > 1) {
            return t('hourStatus');
        }
        else {
            return minTommss(inMinutes);
        }
    };

    return (
        <TableRow key={asset.assetId} className={classes.root} {...rest}>
            <TableCell scope="row" className={classes.innerTd}>
                <ConsoleIcon consoleType={asset.consoleType} />
            </TableCell>
            <TableCell className={classes.innerTd}>
                <div className={classes.consoleTypeCell}>{asset.consoleType}</div>
                <div className={classes.mobileTd1}>
                    {asset.paramount_feature_enabled ? (
                        <div><img alt="LF On Demand Icon" src={lfOnDemandIcon} className={classes.iconImage} />LF On Demand</div>
                    ) : null}
                </div>
            </TableCell>
            <TableCell className={classes.rightAlign + " " + classes.innerTd + " " + classes.mobileTd2}>
                {asset.paramount_feature_enabled ? (
                    <div><img alt="LF On Demand Icon" src={lfOnDemandIcon} className={classes.iconImage} />LF On Demand</div>
                ) : null}
            </TableCell>
            <TableCell className={classes.rightAlign + " " + classes.innerTd}>
                {asset.inUseSince ? (
                    showAvailable ?
                        <Chip icon={<TimerIcon />} label={dateformatting()} color="primary" className={classes.customChip} />
                        :
                        <Chip icon={<TimerIcon />} label={dateformatting()} color="primary" className={classes.customChip} />
                ) : (
                        showAvailable ?
                            <Chip icon={<CastConnectedIcon />} label={t('available')} color="primary" className={classes.customChip} />
                            :
                            <Chip icon={<PowerOffIcon />} label={t('notConnected')} color="primary" className={classes.customChip} />
                    )
                }
            </TableCell>
        </TableRow>
    );
}


Innerasset.propTypes = {
    showAvailable: PropTypes.bool,
    asset: PropTypes.shape({
        bodySerial: PropTypes.string.isRequired,
        consoleType: PropTypes.string.isRequired
    }).isRequired,
};